// extracted by mini-css-extract-plugin
export default {"detailedBody":"inspectionDetailedViewBody_detailedBody__fRCNG","customTabNavClass":"inspectionDetailedViewBody_customTabNavClass__sK1nP"};